import { render } from "./AmountCell.vue?vue&type=template&id=3b128fd8&scoped=true"
import script from "./AmountCell.vue?vue&type=script&lang=js"
export * from "./AmountCell.vue?vue&type=script&lang=js"

import "./AmountCell.vue?vue&type=style&index=0&id=3b128fd8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b128fd8"]])

export default __exports__